import React from "react";
import {
  LuBookOpen,
  LuDatabase,
  LuCode,
  LuEye,
  LuCalendar,
} from "react-icons/lu";
import { Button } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { TYPE_COLORS, getTemplateTypes } from "services/constants";
import localization from "services/localization";
import { useLanguageStore } from "context/useLanguageStore";

export function PromptTemplateCard({ item, onEdit, onDelete, onView }) {
  const { currentLang } = useLanguageStore();
  const TEMPLATE_TYPES = getTemplateTypes();

  const typeLabel =
    TEMPLATE_TYPES.find((t) => t.value === item.type)?.label || item.type;

  return (
    <div className="category-card hover:shadow-xl shadow-md transition-shadow backdrop-blur border mb-4 p-3 rounded-2xl flex-1">
      {/* Name + Type */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-semibold text-lg truncate flex items-center gap-2">
            <LuBookOpen className="title-icon h-6 w-6" />
            {item.name}
          </h3>

          <span
            className={`
              text-xs capitalize border px-2 py-0.5 rounded-full 
              ${TYPE_COLORS[item.type]}
            `}
          >
            {typeLabel}
          </span>
        </div>

        {/* Description */}
        <p className="text-sm line-clamp-2 mb-4 text-description">
          {item.description}
        </p>

        {/* Stats row */}
        <div className="flex items-center gap-4 text-xs text-description">
          <div className="flex items-center gap-1.5">
            <LuDatabase className="h-4 w-4 sub-icon" />
            <span>{item.rag ? "RAG" : "No RAG"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <LuCode className="h-4 w-4 sub-icon" />
            <span>{item.html_format ? "HTML" : "Plain"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <LuEye className="h-4 w-4 sub-icon" />
            <span>
              {item.system_props?.viz_props?.length}{" "}
              {localization.fields || "Fields"}
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-4 pt-4 border-t flex items-center justify-between text-xs text-description">
        <div className="flex items-center gap-1">
          <LuCalendar className="h-4 w-4 sub-icon" />
          <span>
            {localization.updated_label || "Updated"}{" "}
            {new Date(item.updated_at).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </span>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-2 mt-4">
        <Button
          onClick={() => onView(item)}
          size="sm"
          className="action-btn-outline neutral flex-1 align-items-center justify-center gap-2 border transition-all rounded-pill"
        >
          <LuEye className="h-4 w-4" />
          {localization.view || "View"}
        </Button>

        <Button
          onClick={() => onEdit(item)}
          size="sm"
          className="action-btn-outline primary flex-1 align-items-center justify-center gap-2 border transition-all rounded-pill"
        >
          <FaEdit className="h-4 w-4" />
          {localization.edit || "Edit"}
        </Button>

        <Button
          onClick={() => onDelete(item)}
          size="sm"
          className="action-btn-outline danger flex-1 align-items-center justify-center gap-2 border transition-all rounded-pill"
        >
          <FaTrash className="h-4 w-4" />
          {localization.delete || "Delete"}
        </Button>
      </div>
    </div>
  );
}
